(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ag-menu-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  document.querySelectorAll('[data-menu-drawer]').forEach((dialog) => {
    if (dialog.dataset.ready) return;
    dialog.dataset.ready = '1';
    document.querySelectorAll('[data-menu-open]').forEach((b) => b.addEventListener('click', () => dialog.showModal()));
    dialog.querySelectorAll('[data-menu-close]').forEach((b) => b.addEventListener('click', () => dialog.close()));
    dialog.querySelectorAll('[data-wishlist-drawer-open]').forEach((b) => b.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    const toggles = dialog.querySelectorAll('[data-line-toggle]');
    toggles.forEach((btn) => btn.addEventListener('click', () => {
      const line = btn.dataset.lineToggle;
      toggles.forEach((t) => { t.classList.toggle('is-active', t === btn); t.setAttribute('aria-selected', t === btn); });
      dialog.querySelectorAll('[data-line-panel]').forEach((p) => { p.hidden = p.dataset.linePanel !== line; });
    }));
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ag-mobile-tabbar"] && !Shopify.designMode) return;
  try {
    (() => {
  const tpl = document.querySelector('main#MainContent')?.dataset.template || '';
  if (/product|cart/.test(tpl)) document.body.setAttribute('data-template', 'product');
})();
  } catch(e) { console.error(e); }
})();

})();
